    <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="onSelect($event)">
        <ng-container *ngIf="featureFlagsEnum.IntentAutomations | isFeatureFlagEnabled | async; else originalOrder">
            <mat-tab label="PredictiveIntent">
                <ng-template matTabContent>
                    <div class="tab-content border h-full overflow-auto px-6 py-4">
                        <ng-container *ngIf="salesintelPlans?.length; else noPlanMsg">
                            <app-intent
                                [accountTopics]="salesintelAccountTopics"
                                [source]="intentSourceEnum.SALES_INTEL"
                                [plans]="salesintelPlans"
                                [planPropertyValues]="salesintelPropertyValue"
                                [topics]="salesintelTopics"
                                [isLoading]="isLoading || (isLoading$ | async)"
                                (listChange)="onListChange($event, intentSourceEnum.SALES_INTEL)"
                                [disabled]="!(isAdmin$ | async)"
                            ></app-intent>
                        </ng-container>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Bombora Intent">
                <ng-template matTabContent>
                    <div class="tab-content border h-full overflow-auto px-6 py-4">
                        <ng-container *ngIf="bomboraPlans?.length; else noPlanMsg">
                            <app-intent
                                [accountTopics]="bomboraAccountTopics"
                                [source]="intentSourceEnum.BOMBORA"
                                [plans]="bomboraPlans"
                                [planPropertyValues]="bomboraPropertyValue"
                                [topics]="bomboraTopics"
                                [isLoading]="isLoading || (isLoading$ | async)"
                                (listChange)="onListChange($event, intentSourceEnum.BOMBORA)"
                                [disabled]="!(isAdmin$ | async)"
                            ></app-intent>
                        </ng-container>
                    </div>
                </ng-template>
            </mat-tab>
        </ng-container>
        <ng-template #originalOrder>
            <mat-tab label="Bombora Intent" *ngIf="bomboraPlans?.length">
                <ng-template matTabContent>
                    <div class="tab-content border h-full overflow-auto px-6 py-4">
                        <app-intent
                            [accountTopics]="bomboraAccountTopics"
                            [source]="intentSourceEnum.BOMBORA"
                            [plans]="bomboraPlans"
                            [planPropertyValues]="bomboraPropertyValue"
                            [topics]="bomboraTopics"
                            [isLoading]="isLoading || (isLoading$ | async)"
                            (listChange)="onListChange($event, intentSourceEnum.BOMBORA)"
                            [disabled]="!(isAdmin$ | async)"
                        ></app-intent>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="SalesIntel Intent" *ngIf="salesintelPlans?.length">
                <ng-template matTabContent>
                    <div class="tab-content border h-full overflow-auto px-6 py-4">
                        <app-intent
                            [accountTopics]="salesintelAccountTopics"
                            [source]="intentSourceEnum.SALES_INTEL"
                            [plans]="salesintelPlans"
                            [planPropertyValues]="salesintelPropertyValue"
                            [topics]="salesintelTopics"
                            [isLoading]="isLoading || (isLoading$ | async)"
                            (listChange)="onListChange($event, intentSourceEnum.SALES_INTEL)"
                            [disabled]="!(isAdmin$ | async)"
                        ></app-intent>
                    </div>
                </ng-template>
            </mat-tab>
        </ng-template>
    </mat-tab-group>
<ng-template #noPlanMsg>
    <div class="flex flex-col text-center justify-center h-full"><h5>In-market intent signals help you find companies who are ready to buy now. Intent signals are not currently part of your SalesIntel plan. Please contact your SalesIntel representative to add intent signals.</h5></div>
</ng-template>
